import { combineReducers } from 'redux';

import filterOptions from './filter-options';
import filter from './filter';
import posts from './posts';

const reducer = combineReducers({ filter, filterOptions, posts });
export default reducer;
